import React from "react";

const Spinner = () => {
    return <img src="/images/puff.svg" />
}

export default Spinner;
